import { render, staticRenderFns } from "./AssignmentDetailsTab.vue?vue&type=template&id=5d90addf&scoped=true&"
import script from "./AssignmentDetailsTab.vue?vue&type=script&lang=js&"
export * from "./AssignmentDetailsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d90addf",
  null
  
)

export default component.exports